import { render } from "./FormatPercent.vue?vue&type=template&id=52141fd4"
import script from "./FormatPercent.vue?vue&type=script&lang=js"
export * from "./FormatPercent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__